jQuery( document ).ready( function ( $ ) {
	function QUICKLINKS() {
		const blockName = 'jtf/jtf-quicklinks'
		console.log( '[JTF Gut Block - JS] ' + blockName + ' v3.0' )

		this.blockClass = $( '.wp-block-jtf-jtf-quicklinks' )
		this.blockElement = 'jtf__quicklinksblock'
		this.blockTitle = $( '.' + this.blockElement + '--title' )
		this.blockLinks = $( '.' + this.blockElement + '--links' )

		this.init()
	}

	/**
	 * Sets the width of the links part of the quicklinks bar -
	 * sets it to be 100% minus the width of the title part
	 * @param action
	 */
	QUICKLINKS.prototype.resetWidth = function () {
		const self = this
		const titleWidth = self.blockTitle.width() + 30
	}

	/**
	 * Default actions happening on device actions
	 */
	QUICKLINKS.prototype.init = function () {
		const self = this
		// Wipe the placeholder text from the container before populating it with links
		// self.blockLinks.html('');
		// set the width of the links part on first load
		self.resetWidth( true )
		// Scan all blocks to look for id's -
		// if one is found, add it to the main quicklinks list
		$( '.jtf__block' ).each( function () {
			const targetId = $( this ).attr( 'id' )
			const targetCopy = $( this ).attr( 'data-copy' )

			if ( targetId && targetCopy ) {
				self.blockLinks.append(
					'<li role="none"><a href="#' + targetId + '" role="menuitem">' + targetCopy + '</a></li>',
				)
			}
		} )

		self.blockLinks.find( 'a[href*=\\#]' ).not( '.returntotop__container' ).on( 'click', function ( e ) {
			e.preventDefault()
			self.blockLinks.removeClass( self.blockElement + '--links-open' )
			self.blockTitle.removeClass( self.blockElement + '--title-open' )
			self.blockTitle.find( 'button' ).attr( 'aria-expanded', 'false' )

			$( 'html, body' ).animate( {
				scrollTop: $( this.hash ).offset().top - 150,
			}, 500 )
		} )

		// Update the locked state on scroll
		// adds locked state if browser scroll position
		// is lower or equal to the top of the quicklinks container
		$( document ).scroll( function () {
			const topOfParent = self.blockClass.offset().top
			// +100 to this to account for navbars etc at the top,
			// and the quicklinks menu if it's open
			// TODO ADDING 200 TO THIS MAKES IT GO WEIRD WHEN ITS NOT OPEN /// source JTF2
			// HAVE IT ADD 200 ONLY IF THE MENU IS OPEN
			// const currentScrollPosition = $(document).scrollTop() + 200;
			const currentScrollPosition = $( document ).scrollTop()
			$( '.' + self.blockElement ).each( function () {
				const targetId = $( this ).attr( 'id' )
				let offset = $( this ).offset()

				if ( targetId ) {
					if ( offset.top <= currentScrollPosition && currentScrollPosition <= offset.top + $( this ).height() ) {
						// if we match, find the quicklinks link with the href value that matches this blocks ID
						$( '[href=#' + targetId + ']' ).addClass( self.blockElement + '--infocus' )
					} else {
						$( '[href=#' + targetId + ']' ).removeClass( self.blockElement + '--infocus' )
					}
				}
			} )

			if ( currentScrollPosition >= topOfParent ) {
				self.blockClass.addClass( self.blockElement + '--locked' )
				self.blockTitle.find( 'button' ).removeAttr( 'disabled' )
				self.resetWidth( false )
			} else {
				self.blockClass.removeClass( self.blockElement + '--locked' )
				self.blockTitle.find( 'button' ).attr( 'disabled', true )
				self.resetWidth( true )
			}
		} )

		// Google state of dropdown
		self.blockTitle.click( function () {
			const titleOpen = self.blockElement + '--title-open'

			if ( self.blockTitle.hasClass( titleOpen ) ) {
				self.blockTitle.find( 'button' ).attr( 'aria-expanded', 'false' )
			} else {
				self.blockTitle.find( 'button' ).attr( 'aria-expanded', 'true' )
			}
			self.blockLinks.toggleClass( self.blockElement + '--links-open' )
			self.blockTitle.toggleClass( titleOpen )
		} )

		// Reset the width on document resize -
		// stops the forced width calc on desktop breaking mobile
		$( window ).resize( function () {
			self.resetWidth( true )
		} )
	}

	// Check QUICKLINKS is used on this page before instantiating
	if ( $( '.wp-block-jtf-jtf-quicklinks' ).length > 0 ) {
		new QUICKLINKS()
	}
} )
